define('modules/order-matrix',[
  'jquery',
  'settings',

  'views/quick-cart',

  'connections/cart-connection',
  'connections/product-connection',

  'modules/overlay-box',

  'utils/price-format',
  'utils/is-in-view',

  'rivets',
  'moment',
  'utils/rivets-formatters',
], function (
  $,
  settings,
  QuickCart,
  CartConnection,
  ProductConnection,
  OverlayBox,
  priceFormat,
  isInView,
  rivets,
  moment
) {
  'use strict';
  return (function () {
    function OrderMatrix(container) {
      this.container = container;
      this.el = container.find('.order-matrix-wrapper__inner'); // if not loaded by ajax, the matrix is already rendered.
      this.configurationPrices = {};
      this._replacementData = {
        info: {
          availableDate: '',
        },
      };
    }

    /**
     * If view should be loaded via template
     */
    OrderMatrix.prototype.load = function () {
      var _this = this;

      ProductConnection.getMatrixView(this.productId).then(function (res) {
        if (res) {
          var el = $(res);

          _this.container.append(el);
          _this.el = el;
          _this.init();
        }
      });
    };

    /**
     * Request product data by product ID
     * @param {String} pid Product ID
     * @method setProductData
     */
    OrderMatrix.prototype.setProductData = function (pid, productReplaceId) {
      this.productId = pid;
      this.productReplaceId = productReplaceId;
    };

    /**
     * @method init
     */
    OrderMatrix.prototype.init = function () {
      if (this.el.find(['data-error']).length) return;

      this._initMatrixWithLockedWidth();
      this._initVisualColumnAndRowGuide();
      this._initInventoryBinding();
      this._initActiveInputs();
      this._bindReplacementProduct();


      if (this._onRenderCallback) {
        this._onRenderCallback();
      }

      // if ($('#product-view').attr('matrix-suggest-replacement-product')) this.loadReplacementProduct(); 
    };

    OrderMatrix.prototype.loadAndRenderReplacementProduct = function (cb) {
      var _this = this;

      // Load the replacement Product data view
      return ProductConnection.getReplacementProductBoxView(_this.productReplaceId).then(function (html) {
        _this._renderReplacementProduct(html);
        _this.bindCloseReplacementPopupButton();
        if (cb) cb();
      });
    };

    /**
     * @method _renderReplacementProduct
     * @private
     */
    OrderMatrix.prototype._renderReplacementProduct = function (html) {
      this.replacementEl = $(html);
      this.container.append(this.replacementEl);
      this._onWindowResize();
    };

    /**
     * @method _bindReplacementProduct
     * @private
     */
    OrderMatrix.prototype._bindReplacementProduct = function () {
      var _this = this;
      var $cellInput;

      function showPopup()  {
        var availableDate = $cellInput.data('availableDate');
        var availableMoment = moment(availableDate);

        _this._renderAndShowReplacement($cellInput, availableDate);

        // Show warning icon if delivery date is more than a year in the future
        // = the product is not coming back in stock
        if (moment().add(1, 'y').isBefore(availableMoment))
          $('.info .note-icon').show();
        else
          $('.info .note-icon').hide();

        _this.bindClickOutsideToClose();
      }


      this.el.on('focus', '[data-render-replacement="1"]', function (e) {
        if (this.replacementEl && _this.replacementEl.hasClass('order-matrix__product-replace--visible')) return;
        $cellInput = $(this);
        if (!_this.replacementEl) _this.loadAndRenderReplacementProduct(showPopup);
        else showPopup();
      });
    };

    /**
     * @method _onWindowResize
     * @private
     */
    OrderMatrix.prototype._onWindowResize = function () {
      var _this = this;
      $(window).resize(function () {
        if (_this.replacementEl.hasClass('order-matrix__product-replace--visible')) {
          _this.replacementEl.removeClass('order-matrix__product-replace--visible');

          if (document.activeElement.length > 0) {
            _this._renderAndShowReplacement($(document.activeElement));
          }
        }
      });
    };

    /**
     * @method _renderAndShowReplacement
     * @param zeroPos
     * @private
     */
    OrderMatrix.prototype._renderAndShowReplacement = function (cellInput, date) {
      var _this = this;
      var winWidth = $(window).width();
      var spanReplacement = _this.replacementEl.find('> span');
      var elReplacementWidth = _this.replacementEl.outerWidth(true);
      var elReplacementHeight = _this.replacementEl.outerHeight(true);
      var spanReplacementWidth = spanReplacement.outerWidth(true);
      var tableCol = $('.order-matrix__col-description');
      var tableRow = $('.order-matrix__row-description');
      var tableColWidths = tableCol.map(function () {
        return $(this).outerWidth();
      });
      var tableRowHeights = tableRow.map(function () {
        return $(this).outerHeight();
      });
      var tableColOffsets = tableCol.map(function () {
        return $(this).offset().left;
      });
      var tableRowOffsets = tableRow.map(function () {
        return $(this).offset().top;
      });

      _this.replacementEl.find('[data-availability-date]').text(date);

      //$(elReplacement).css({"left":"-999px"; "display":"block"});
      var cr = _this._getRowAndColDesc(tableCol);
      _this._checkHeaderVisibility(cr);
      
      var pos = _this._getRowAndColNum(cellInput);
      var offsetX = tableColOffsets[pos.col];
      var offsetY = tableRowOffsets[pos.row];

      // Calculates where the arrow and the popup should be
      var mainLeftOffset = Math.round(offsetX - elReplacementWidth / 2 + tableColWidths[pos.col] / 2);
      var spanLeftOffset = Math.round(elReplacementWidth / 2 - spanReplacementWidth / 2);
      var mainTopOffset = Math.round(offsetY + tableRowHeights[pos.row] + elReplacementHeight);

      // Offset if the popups right side is outside of the viewport
      if (Math.round(mainLeftOffset + elReplacementWidth) > winWidth) {
        var o = winWidth - (mainLeftOffset + elReplacementWidth);
        mainLeftOffset = mainLeftOffset + o - 10;
        spanLeftOffset = elReplacementWidth / 2 - spanReplacementWidth / 2 - o;
      }
      // Offset if the popups left side is outside of the viewport
      if (Math.round(mainLeftOffset < 0)) {
        mainLeftOffset = 10;
        spanLeftOffset = offsetX + spanReplacementWidth - tableColWidths[pos.col] / 2;
      }

      // Sets the replacement product elements top offset
      _this.replacementEl.css({ top: mainTopOffset });

      if (spanLeftOffset < 0) {
        spanLeftOffset = 0;
      } else if (spanLeftOffset > elReplacementWidth - spanReplacementWidth) {
        spanLeftOffset = elReplacementWidth - spanReplacementWidth;
      }

      // Sets the popups left offset
      _this.replacementEl.css({ left: mainLeftOffset });

      // Sets the arrows left/top offset
      spanReplacement.css({ top: 0 - spanReplacement.outerHeight(true) / 2, left: spanLeftOffset });

      // Shows the popup
      _this.replacementEl.addClass('order-matrix__product-replace--visible');
    };

    /**
     * @method closeReplacementPopup
     */
    OrderMatrix.prototype.closeReplacementPopup = function () {
      this.replacementEl.css('left', '').removeClass('order-matrix__product-replace--visible');
    };

    /**
     * @method closeReplacementPopupButton
     */
    OrderMatrix.prototype.bindCloseReplacementPopupButton = function () {
      var _this = this;
      var lastFocus;

      $('.order-matrix')
        .find('.order-matrix__piece-count-input')
        .focus(function () {
          lastFocus = $(this);
        });

      $(document).on('click', '[data-close-replacement]', function (e) {
        e.preventDefault();

        // Keep focus on order matrix input when closing replacement product popup
        if (lastFocus.length === 1) {
          lastFocus.focus();
        }

        _this.closeReplacementPopup();
        $(document).off('mousedown.replacePopup');
      });
    };

    /**
     * @method _clickOutsideOpenedReplacementPopup
     * @private
     */
    OrderMatrix.prototype.bindClickOutsideToClose = function () {
      var _this = this;

      $(document)
        .off('mousedown.replacePopup')
        .on('mousedown.replacePopup', function (event) {
          var $target = $(event.target);
          var doTrigger = $target.closest('.order-matrix__product-replace').length < 1 && $target.data('renderReplacement') !== 1;

          if (doTrigger) {
            _this.closeReplacementPopup();
            $(this).off('mousedown.replacePopup');
          }
        });
    };

    /**
     * Add selected items to cart.
     *
     * @method addToCart
     * @public
     */
    OrderMatrix.prototype.addToCart = function () {
      var skuOrderObjects = this.getProductInput(true);
      var deferred = $.Deferred();

      if (skuOrderObjects.length) {
        var stockQuantiyExceeded = false;
        skuOrderObjects.forEach(function (data) {
          if (data.stock - data.quantity < 0) {
            stockQuantiyExceeded = true;
          }
        });

        if (stockQuantiyExceeded && settings.exceedAvailableStockWarningEnabled) {
          var ob = new OverlayBox(settings.templates.stockQtyWarning, {});
          ob.setup();
          ob.load(function () {
            ob.show();
            $('[confirm-stock-qty-warning]').one('click', function () {
              CartConnection.add(skuOrderObjects).then(function (res) {
                QuickCart.printTotalQuantity(res);

                deferred.resolve();
              });

              ob.destroy();
            });
            $('[cancel-stock-qty-warning]').one('click', function () {
              ob.destroy();
              deferred.resolve();
            });
          });
        } else {
          CartConnection.add(skuOrderObjects).then(function (res) {
            QuickCart.printTotalQuantity(res);

            deferred.resolve();
          });
        }
      } else deferred.reject();

      return deferred.promise();
    };

    OrderMatrix.prototype.getProductInput = function (clear) {
      var inputs = this.el.find('.order-matrix__piece-count-input').filter(function (i, el) {
        return parseInt($(el).val()) > 0;
      });
      var allInputData = [];

      if (inputs.length) {
        var _this = this;

        inputs.each(function () {
          var inputEl = $(this);
          var cellData = _this.getDataFromCell(_this.getParentCell(inputEl));
          var row = _this.getParentRow(inputEl);
          var inputData = {
            sku: cellData.sku,
            quantity: parseInt(inputEl.val()),
            size: cellData.sizename,
            color: row.data('colorname'),
            stock: cellData.stockDisplayed,
          };

          allInputData.push(inputData);

          if (clear) {
            inputEl.val('').trigger('change');
          }
        });
      }

      return allInputData;
    };

    /**
     * @method onRender
     * @param cb
     */
    OrderMatrix.prototype.onRender = function (cb) {
      this._onRenderCallback = cb;
    };

    /**
     * Locks the width of matrix to be able to scroll it.
     * @method _renderMatrixWithLockedWidth
     */
    OrderMatrix.prototype._initMatrixWithLockedWidth = function () {
      var _this = this;
      var $outerWrapper = $('.order-matrix-wrapper');
      var $innerWrapper = this.el.find('.order-matrix-wrapper__inner');
      var $matrix = this.el.find('.order-matrix');

      // Lock width.
      $matrix.css('width', $matrix.outerWidth());

      // Position background table
      $('.order-matrix__background').css(
        'left',
        $('.order-matrix th')
          .first()
          .outerWidth()
      );

      // Set vertical scroll if matrix is wider than window
      var $scrollbox = this.el.find('.order-matrix__scrollbox');
      this._checkMatrixOverflowScroll($matrix, $outerWrapper, $scrollbox);
      $(window).on('resize', function () {
        _this._checkMatrixOverflowScroll($matrix, $outerWrapper, $scrollbox);
      });

      //Position matrix
      var innerWrapperWidth = $innerWrapper.outerWidth();
      var outerWrapperWidth = $outerWrapper.outerWidth();
      var matrixWidth = this.el.find('.order-matrix').outerWidth();

      if (outerWrapperWidth > matrixWidth) {
        $outerWrapper.scrollLeft(innerWrapperWidth - outerWrapperWidth);
      } else {
        $outerWrapper.scrollLeft(innerWrapperWidth - matrixWidth);
      }
    };

    OrderMatrix.prototype._checkMatrixOverflowScroll = function ($matrix, $wrapper, $scrollbox) {
      if ($matrix.outerWidth() > $wrapper.width()) {
        $scrollbox.css('overflow-x', 'scroll');
      } else {
        $scrollbox.css('overflow-x', 'initial');
      }
    };

    /**
     * @method _initInventoryBinding
     * @private
     */
    OrderMatrix.prototype._initInventoryBinding = function () {
      var _this = this;
      var currentInventoryTooltip = $('.order-matrix__warehouse-stock');
      var currentInventoryTooltipVisibleClass = 'order-matrix__warehouse-stock--visible';
      var closeInventoryTooltip = function () {
        currentInventoryTooltip.removeClass(currentInventoryTooltipVisibleClass);
      };
      this.inventoryAndPrice = {
        local: '-',
        region: '-',
        total: '-',
        price: null,
        globalStockSKU: null,
        global: false,
      };

      this.viewBinding = rivets.bind(this.el, this.inventoryAndPrice);

      this.el.on('click', function (e) {
        e.preventDefault();
        if ($(e.target).hasClass('order-matrix__close-button')) {
          closeInventoryTooltip();
        }
      });

      $(document).on('click.closeStock', function (event) {
        if (
          $(event.target).parents('.order-matrix-wrapper').length < 1 &&
          !$(event.target).hasClass('replace-box__action-close')
        ) {
          closeInventoryTooltip();
        }
      });

      this.el.find('.order-matrix__piece-count-input').on('focus', function () {
        try {
          var config = _this.getDataFromCell($(this));

          if (config.stockSetting == 'Local') {
            _this.inventoryAndPrice.local = config.local;

            $('.order-matrix__warehouse-stock__local').show();
            $('.order-matrix__warehouse-stock__europe').hide();
          } else if (config.stockSetting == 'MDC') {
            _this.inventoryAndPrice.region = config.region;

            $('.order-matrix__warehouse-stock__local').hide();
            $('.order-matrix__warehouse-stock__europe').show();
          } else if (config.stockSetting == 'LocalMDC') {
            _this.inventoryAndPrice.local = config.local;
            _this.inventoryAndPrice.region = config.region;

            $('.order-matrix__warehouse-stock__local').show();
            $('.order-matrix__warehouse-stock__europe').show();
          } else if (config.stockSetting == 'Global') {
            _this.inventoryAndPrice.local = config.local;
            _this.inventoryAndPrice.region = config.region;

            $('.order-matrix__warehouse-stock__local').show();
            $('.order-matrix__warehouse-stock__europe').show();
          }

          $('.order-matrix__warehouse-stock__global').show();
          if (config.hideGlobal) {
            $('.order-matrix__warehouse-stock__global').hide();
          }

          _this.inventoryAndPrice.globalStockSKU = config.sku;
          _this.inventoryAndPrice.total = config.global;
          _this._loadPrice(config);

          currentInventoryTooltip.addClass(currentInventoryTooltipVisibleClass);
        } catch (err) {
          console.error('Unable to load inventory quantities.');
        }
      });

      // Toggle fixed inventory and price tooltip on scroll
      _this._setToolTipPosition();

      $(window).on('resize', function () {
        _this._setToolTipPosition();
      });
    };

    OrderMatrix.prototype.getDataFromCell = function ($el) {
      return this.getParentCell($el).data();
    };

    /**
     * @method _setToolTipPosition
     * @private
     */
    OrderMatrix.prototype._setToolTipPosition = function () {
      var _this = this,
        cr = _this._getRowAndColDesc($('.order-matrix__col-description')),
        om = $('.order-matrix-wrapper'),
        tooltip = $('.order-matrix__warehouse-stock__details');

      tooltip.css({ width: om.outerWidth() });

      $(document).on('scroll', function () {
        var visibleHeaders = _this._checkHeaderVisibility(cr),
          omTopOffset = om.offset().top,
          omBottomOffset = om.offset().top + om.outerHeight() - 40,
          scrollTop = $(document).scrollTop();

        if (!visibleHeaders.top && scrollTop > omTopOffset && scrollTop < omBottomOffset) {
          tooltip.addClass('order-matrix__warehouse-stock__details--fixed');
        } else {
          tooltip.removeClass('order-matrix__warehouse-stock__details--fixed');
        }
      });
    };

    /**
     * @method _loadPrice
     * @param sku
     * @private
     */
    OrderMatrix.prototype._loadPrice = function (config) {
      var _this = this;
      var sku = config.sku;
      var priceEle = $('.order-matrix__warehouse-stock__price');
      
      if (this.configurationPrices.hasOwnProperty(sku)) {
        priceEle.html(_this.configurationPrices[sku]);
        return;
      }
      
      priceEle.html(priceEle.data('loading'));
      ProductConnection.getCustomerPriceView(sku).then(
        function (html) {
          _this.configurationPrices[sku] = html;
          priceEle.html(html);
        }
      );
    };

    /**
     * Makes the input fields to get the --active-class when
     * they have a value exceeding 0
     *
     * @method _initActiveInputs
     * @private
     */
    OrderMatrix.prototype._initActiveInputs = function () {
      var activeClass = 'order-matrix__piece-count-input--active';

      $('.order-matrix__piece-count-input').on('change', function () {
        if ($(this).val() > 0) {
          $(this).addClass(activeClass);
        } else {
          $(this).removeClass(activeClass);
        }
      });
    };

    /**
     * Get the column number and row number for a given element
     *
     * @method _getRowAndColDesc
     * @param el
     * @returns {{col: *, row: *}}
     * @private
     */
    OrderMatrix.prototype._getRowAndColDesc = function (el) {
      return {
        col: el
          .closest('table')
          .find('th')
          .eq(el.index()),
        row: el.parent().find('.order-matrix__row-description'),
      };
    };

    /**
     * Get's the col and row pos
     *
     * @method _getRowAndColNum
     * @param el
     * @returns {{col: number, row: number}}
     * @private
     */
    OrderMatrix.prototype._getRowAndColNum = function (el) {
      el = this.getParentCell(el);
      return {
        col: el.index() - 1,
        row: el.closest('tr').index(),
      };
    };

    OrderMatrix.prototype.getParentCell = function (el) {
      if (!el.is('td')) {
        el = el.closest('td');
      }
      return el;
    };

    OrderMatrix.prototype.getParentRow = function (el) {
      if (!el.is('tr')) {
        el = el.closest('tr');
      }
      return el;
    };

    /**
     * @method _initVisualColumnAndRowGuide
     * @private
     */
    OrderMatrix.prototype._initVisualColumnAndRowGuide = function () {
      var _this = this;

      $('.order-matrix__col-piece-count')
        .on('mouseenter', function () {
          // Safari fix
          $(this)
            .find('.order-matrix__piece-count-overlay')
            .hide();

          // Prevent binding on touch devices.
          if (Modernizr.touch) return;

          var cr = _this._getRowAndColDesc($(this));
          var visibleHeaders = _this._checkHeaderVisibility(cr);

          cr.row.addClass('order-matrix__row-description--active');
          cr.col.addClass('order-matrix__col-description--active');

          if (!visibleHeaders.top || !visibleHeaders.left) {
            var tooltip = $(this).find('.order-matrix-col-piece-count__tooltip');
            var tooltipContent = $(this).find('.order-matrix-col-piece-count__tooltip__content');
            var rowText = '',
              colText = '';

            if (!visibleHeaders.left) rowText = '<span>' + cr.row.text() + '</span>';
            if (!visibleHeaders.top) colText = '<span>' + cr.col.text() + '</span>';

            var textEl = (rowText && colText) ? $(rowText + ' <span>/</span> ' + colText).css({ 'max-width': '4rem' }) : $(rowText + colText);

            tooltip.addClass('active');
            tooltipContent.append(textEl);
          }
        })
        .on('mouseleave', function () {
          var cr = _this._getRowAndColDesc($(this));
          var tooltip = $(this).find('.order-matrix-col-piece-count__tooltip');
          var tooltipContent = $(this).find('.order-matrix-col-piece-count__tooltip__content');

          // Safari fix
          $(this)
            .find('.order-matrix__piece-count-overlay')
            .show();

          cr.row.removeClass('order-matrix__row-description--active');
          cr.col.removeClass('order-matrix__col-description--active');

          tooltip.removeClass('active');
          tooltipContent.empty();
        });

      $('.order-matrix__piece-count-input')
        .on('focus', function () {
          var cr = _this._getRowAndColDesc($(this).parent());

          cr.row.addClass('order-matrix__row-description--focused');
          cr.col.addClass('order-matrix__col-description--focused');
        })
        .on('blur', function () {
          var cr = _this._getRowAndColDesc($(this).parent());

          cr.row.removeClass('order-matrix__row-description--focused');
          cr.col.removeClass('order-matrix__col-description--focused');
        });
    };

    OrderMatrix.prototype._checkHeaderVisibility = function (headers) {
      var top = isInView(headers.col, null, $('.navigation-bar').outerHeight(), null, 0.5);
      // REVIEW: Not sure if needed?
      var left = isInView(headers.row);
      var leftScroll =
        this._scrolledLeftAmount() < $('.order-matrix__warehouse-stock').outerWidth() + headers.row.outerWidth() / 2;

      return { top: top, left: left && leftScroll };
    };

    OrderMatrix.prototype._scrolledLeftAmount = function () {
      return $('.order-matrix-wrapper').scrollLeft();
    };

    return OrderMatrix;
  })();
});

